import { createContext, useMemo, useReducer } from 'react'

const GlobalContext = createContext()

const INITIAL_STATE = {
  forgotDetails: false,
  forgotType: null,
  isAlternativeActive: false,
  showThankYouPage: false,
  showThankYouPageFields: null,
  csrfToken: null,
}

export const GlobalProvider = ({ children }) => {
  const reducer = (state, { type, payload }) => {
    switch (type) {
      case 'changeIsAlternativeActive':
        return { ...state, isAlternativeActive: payload }
      case 'changeCsrfToken':
        return { ...state, csrfToken: payload }
      case 'changeForgotType':
        return { ...state, forgotType: payload, forgotDetails: true }
      case 'changeShowThankYouPage':
        return {
          ...state,
          showThankYouPage: true,
          showThankYouPageFields: payload,
        }
      case 'reset':
        return INITIAL_STATE
      default:
        return state
    }
  }

  const [state, dispatch] = useReducer(reducer, INITIAL_STATE)
  return useMemo(
    () => (
      <GlobalContext.Provider value={{ state, dispatch }}>
        {children}
      </GlobalContext.Provider>
    ),
    [state, children]
  )
}

export default GlobalProvider
export { GlobalContext }
